import { Typography } from '@mui/material';
import React from 'react'

const RegisterPage = () => {
    return ( <div>
        <Typography>Register</Typography>
    </div> );
}
 
export default RegisterPage;